
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as demonfyCpodhb5TRAan3mMrTamoToNu5mZ7VAsu_HbELBMIMeta } from "/vercel/path0/pages/demo.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as inquirefkdbJLC4J04r_3tvPkiDULxxfk_Xi1MNzi28PEXbeeUMeta } from "/vercel/path0/pages/inquire.vue?macro=true";
import { default as feedbackNOvNFeZlpOxVT1vhwaXdbCG7GPXRkqHY19pyPwfBh2AMeta } from "/vercel/path0/pages/feedback.vue?macro=true";
import { default as indexFQKJnHlB25K87EFZVJWeA2ZYhVetQCgEq9JrTGVTke0Meta } from "/vercel/path0/pages/auth/index.vue?macro=true";
import { default as indexDIlA_VwVYEsF82JYYTptIRBexsOVSbsbgl1xBQ_lIIoMeta } from "/vercel/path0/pages/blog/index.vue?macro=true";
import { default as _91blog_93gRaE81J9IbO3JjYjdasrbBw4fB2hOLrDd1XcMliwkxcMeta } from "/vercel/path0/pages/blog/[blog].vue?macro=true";
import { default as indexOJJqd7BbHjDyf0bLKKa5FAZIXVX8zPgYa4wQdOwWPeMMeta } from "/vercel/path0/pages/users/index.vue?macro=true";
import { default as notificationsbtjm_INo6lozseH9LyNaDmyAYKp7VgP2qPJhWaYIcm0Meta } from "/vercel/path0/pages/notifications.vue?macro=true";
import { default as search_45historyKcaQb1pGcXRDk22_45ikedrSX6muxnM2skEaHG858Fer0Meta } from "/vercel/path0/pages/search-history.vue?macro=true";
import { default as settingsc8ZXTcJdjM7LOYdZjSGyc2KIIQIjufu53_45Szk8OD0yUMeta } from "/vercel/path0/pages/users/settings.vue?macro=true";
import { default as _91address_93LuAKSClkrNjM9ZulFDRSgnOUyQx_45LSuonaOjrOoSPZgMeta } from "/vercel/path0/pages/report/[address].vue?macro=true";
import { default as inquiry_45analytics0J2FfhOZv5GwHXDtjHADm6AcEKCgMHgvdzGLJxqNIFgMeta } from "/vercel/path0/pages/inquiry-analytics.vue?macro=true";
import { default as assessment_45history4oip5KSSUD4VV4CUi2Zw5oZTA3mq2jZcrybwcj__45Ss0Meta } from "/vercel/path0/pages/assessment-history.vue?macro=true";
import { default as indexTVl3fTkMjq3mktEsb3ScbrLqX1glcb_45XobunZTcyr_45sMeta } from "/vercel/path0/pages/subscription/index.vue?macro=true";
import { default as edit8VWyUFjSjNi8vtt8_45ETsrrun29aV1bGh_45MhA8a3k2RgMeta } from "/vercel/path0/pages/zoning-editor/edit.vue?macro=true";
import { default as edite4OMMoh0syxUi73h4a5rao14EdP3TQUmk3Omjhgi5cQMeta } from "/vercel/path0/pages/modules-editor/edit.vue?macro=true";
import { default as index_45s3Doc5ebMEZBii0JZeAA6fyTbFqva2f1jtlvURwrVsMeta } from "/vercel/path0/pages/zoning-editor/index.vue?macro=true";
import { default as indext4t1zv2QYJ_45RGQHnMwLsO5s5fjVxeuZK9ssQ4PWS82wMeta } from "/vercel/path0/pages/modules-editor/index.vue?macro=true";
import { default as createsHE29gNuqmOXtKkMbjPgmoXzKjwLstwrGLeSQObqvjsMeta } from "/vercel/path0/pages/zoning-editor/create.vue?macro=true";
import { default as createNas_EcBsMv0IlDeeYvShsQvE2irvVzmdBaR_45EYbSxQ8Meta } from "/vercel/path0/pages/modules-editor/create.vue?macro=true";
import { default as checkoutH1Hj3Mjv9bDgFbStTHYTsF6RPR0yZlszfk2AQGLxcFgMeta } from "/vercel/path0/pages/subscription/checkout.vue?macro=true";
import { default as testingsxJkLKkO3A69VHnMqLZVtJU6F4r_45OLnrDhDZiywaIuQMeta } from "/vercel/path0/pages/zoning-editor/testing.vue?macro=true";
import { default as _91address_93H8HEiOubuHjqRzSEPq9WxXWujzN_h82bJdYK_85Mpo0Meta } from "/vercel/path0/pages/inquiry-report/[address].vue?macro=true";
import { default as indexPZnjSL40DxCngyDBKWvL9u2SazK2WIRlySxFac9trP8Meta } from "/vercel/path0/pages/auth/forgot-password/index.vue?macro=true";
import { default as reverse_45searchRzPzEum0OFEUPTAKc9_45PBCXPiIXNH7RlvMxzmjwExeAMeta } from "/vercel/path0/pages/zoning-editor/reverse-search.vue?macro=true";
import { default as _91address_93fgcxkdR7nR70cnZymRRNGwesz8WJcLjRs_NAC2xYiK4Meta } from "/vercel/path0/pages/planner-inquiry-report/[address].vue?macro=true";
import { default as _91inquirySubmissionId_93tCoHtjsxLZcWRtw_45w8UuGsYgqvKUDU2mHorop_45PGsfwMeta } from "/vercel/path0/pages/inquiry-report/result/[inquirySubmissionId].vue?macro=true";
import { default as building_45typologies_45hierarchy1oakOP_45d6uZD4IQEJDpDvqjN9YBMlmEP0QYtKV2XqR0Meta } from "/vercel/path0/pages/zoning-editor/building-typologies-hierarchy.vue?macro=true";
import { default as building_45typologies_45simulationjvkFyw_45lqg_45r6P3LtCBvuNcKhSDuI58hRSKSFYDbA3MMeta } from "/vercel/path0/pages/zoning-editor/building-typologies-simulation.vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "demo",
    path: "/demo",
    component: () => import("/vercel/path0/pages/demo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "inquire",
    path: "/inquire",
    component: () => import("/vercel/path0/pages/inquire.vue")
  },
  {
    name: "feedback",
    path: "/feedback",
    component: () => import("/vercel/path0/pages/feedback.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/vercel/path0/pages/auth/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/pages/blog/index.vue")
  },
  {
    name: "blog-blog",
    path: "/blog/:blog()",
    component: () => import("/vercel/path0/pages/blog/[blog].vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/vercel/path0/pages/users/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/vercel/path0/pages/notifications.vue")
  },
  {
    name: "search-history",
    path: "/search-history",
    component: () => import("/vercel/path0/pages/search-history.vue")
  },
  {
    name: "users-settings",
    path: "/users/settings",
    component: () => import("/vercel/path0/pages/users/settings.vue")
  },
  {
    name: "report-address",
    path: "/report/:address()",
    component: () => import("/vercel/path0/pages/report/[address].vue")
  },
  {
    name: "inquiry-analytics",
    path: "/inquiry-analytics",
    component: () => import("/vercel/path0/pages/inquiry-analytics.vue")
  },
  {
    name: "assessment-history",
    path: "/assessment-history",
    component: () => import("/vercel/path0/pages/assessment-history.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    component: () => import("/vercel/path0/pages/subscription/index.vue")
  },
  {
    name: "zoning-editor-edit",
    path: "/zoning-editor/edit",
    component: () => import("/vercel/path0/pages/zoning-editor/edit.vue")
  },
  {
    name: "modules-editor-edit",
    path: "/modules-editor/edit",
    component: () => import("/vercel/path0/pages/modules-editor/edit.vue")
  },
  {
    name: "zoning-editor",
    path: "/zoning-editor",
    component: () => import("/vercel/path0/pages/zoning-editor/index.vue")
  },
  {
    name: "modules-editor",
    path: "/modules-editor",
    component: () => import("/vercel/path0/pages/modules-editor/index.vue")
  },
  {
    name: "zoning-editor-create",
    path: "/zoning-editor/create",
    component: () => import("/vercel/path0/pages/zoning-editor/create.vue")
  },
  {
    name: "modules-editor-create",
    path: "/modules-editor/create",
    component: () => import("/vercel/path0/pages/modules-editor/create.vue")
  },
  {
    name: "subscription-checkout",
    path: "/subscription/checkout",
    component: () => import("/vercel/path0/pages/subscription/checkout.vue")
  },
  {
    name: "zoning-editor-testing",
    path: "/zoning-editor/testing",
    component: () => import("/vercel/path0/pages/zoning-editor/testing.vue")
  },
  {
    name: "inquiry-report-address",
    path: "/inquiry-report/:address()",
    component: () => import("/vercel/path0/pages/inquiry-report/[address].vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    component: () => import("/vercel/path0/pages/auth/forgot-password/index.vue")
  },
  {
    name: "zoning-editor-reverse-search",
    path: "/zoning-editor/reverse-search",
    component: () => import("/vercel/path0/pages/zoning-editor/reverse-search.vue")
  },
  {
    name: "planner-inquiry-report-address",
    path: "/planner-inquiry-report/:address()",
    component: () => import("/vercel/path0/pages/planner-inquiry-report/[address].vue")
  },
  {
    name: "inquiry-report-result-inquirySubmissionId",
    path: "/inquiry-report/result/:inquirySubmissionId()",
    component: () => import("/vercel/path0/pages/inquiry-report/result/[inquirySubmissionId].vue")
  },
  {
    name: "zoning-editor-building-typologies-hierarchy",
    path: "/zoning-editor/building-typologies-hierarchy",
    component: () => import("/vercel/path0/pages/zoning-editor/building-typologies-hierarchy.vue")
  },
  {
    name: "zoning-editor-building-typologies-simulation",
    path: "/zoning-editor/building-typologies-simulation",
    component: () => import("/vercel/path0/pages/zoning-editor/building-typologies-simulation.vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/.well-known/:pathMatch(.*)",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]